/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { entityService } from './services';

const pathname = '/entity-lark-apps';

export const EntityLarkAppApi = {
  filter: async (options: FilterEntityLarkAppsOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.post(url);
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkConnect: async body => {
    const url = `${pathname}/check-connection`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanDelete: async (id: string) => {
    const url = `${pathname}/check-can-delete/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterEntityLarkAppsOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityID?: string;
  status?: number;
}
